import { Injectable } from '@angular/core';
import { DateNumbers } from '@global/infrastructure/enums/date-numbers.enum';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private convertDaysToMilliseconds(days: number): number {
    return (
      days *
      DateNumbers.hoursPerDay *
      DateNumbers.minutesPerHour *
      DateNumbers.secondsPerMinute *
      DateNumbers.millisecondsPerSecond
    );
  }

  public setCookie(name: string, value: string, days: number): void {
    let expires = '';

    if (days) {
      const date: Date = new Date();
      date.setTime(date.getTime() + this.convertDaysToMilliseconds(days));
      expires = date.toUTCString();
    }

    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  public getCookie(name: string): string {
    const nameLengthEnd = name.length + 1;
    return (
      document.cookie
        .split(';')
        .map((c) => c.trim())
        .filter((cookie) => {
          return cookie.substring(0, nameLengthEnd) === `${name}=`;
        })
        .map((cookie) => {
          return decodeURIComponent(cookie.substring(nameLengthEnd));
        })[0] || null
    );
  }
}
